var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA3LedOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46 32a8 8 0 00-16 0v9h-5v11h6v11h4V52h6v11h4V52h6V41h-5v-9zm-12 0a4 4 0 118 0v9h-8v-9zm5.94-14.66h-4v-6h4v6zm9 6.62l-2.83-2.83 4.24-4.24 2.83 2.83-4.24 4.24zM27.09 24l-4.24-4.24 2.83-2.83 4.24 4.24L27.09 24z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A3_LED_on.e6b56a85.svg";
export { SvgA3LedOn as ReactComponent };